import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeplerCoveoService, SearchRecommendationEngineService } from '@services';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

export const searchRecommendationsEngineGuard: CanActivateFn = async () => {
    const recommendationEngine = inject(SearchRecommendationEngineService);
    const keplerCoveoService = inject(KeplerCoveoService);

    if (recommendationEngine.isInitialized()) {
        return true;
    }

    try {
        const token = await firstValueFrom(
            keplerCoveoService.searchToken$(environment.gknSearch.searchRecommendationEngineConfiguation.searchHub),
        );
        recommendationEngine.init(token);
        return true;
    } catch (error) {
        console.error('Failed to initialize Search recommendations engine:', error);
        return false;
    }
};
